<template>
  <div
    :class="`hs-cta-embed hs-cta-simple-placeholder hs-cta-embed-${hubspotId}`"
    :data-hubspot-wrapper-cta-id="hubspotId"
    style="max-width: 100%; max-height: 100%"
  >
    <a :href="href" target="_blank" rel="noopener noreferrer">
      <img
        :alt="imgAlt || 'Logo'"
        loading="lazy"
        :src="imgSrc"
        @error="handleImageError"
        style="max-width: 100%; height: auto"
      />
    </a>
  </div>
</template>

<script>
export default {
  name: 'HubspotCard',
  props: {
    hubspotId: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    imgSrc: {
      type: String,
      required: true,
    },
    imgAlt: {
      type: String,
      default: 'Logo',
    },
  },
  methods: {
    initializeWebInteractives() {
      const existingScripts = [
        document.getElementById('hs-web-interactives-loader'),
        document.getElementById('hs-web-interactives-top-anchor'),
        document.getElementById('hs-web-interactives-top-push-anchor'),
        document.getElementById('hs-web-interactives-bottom-anchor'),
        document.getElementById('hs-web-interactives-floating-container'),
      ]
      existingScripts.forEach(script => {
        if (script) script.remove()
      })
      window.hubspot_web_interactives_running = false
      const script = document.createElement('script')
      script.id = 'hs-web-interactives-loader'
      script.src = 'https://js.hubspot.com/web-interactives-embed.js'
      script.async = true
      document.body.appendChild(script)
    },
    handleImageError(event) {
      event.target.style.display = 'none'
    },
  },
  mounted() {
    this.initializeWebInteractives()
  },
}
</script>
